// extracted by mini-css-extract-plugin
export default {"container":"CzzwSF","thumbnailRatioContainer":"Uj03iG"};